import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PStepConfig } from '../model/p-step-config';
import { PStepState } from './p-step-state.enum';
import { ButtonTypeEnum } from '@panaya/ui/p-button';

@Component({
    selector: 'p-stepper',
    template: `
        <div *ngFor="let step of steps; let stepIndex = index" class="step-wrapper">
            <p-step [context]="step.context" [template]="step.template" [state]="getStepState(step)" [index]="stepIndex"></p-step>
            <div class="step-controller" *ngIf="isDisplayButtonsBar(step, stepIndex)">
                <p-button
                    [attr.automation-id]="step.context.phaseId + '-Prev'"
                    (buttonClicked)="prevStepClick.emit()"
                    *ngIf="stepIndex > 0"
                    iconAfter="arrow-up"
                    [buttonType]="ButtonTypeEnum.Tertiary"
                    [label]="'pStepper.prevStep' | translate"
                >
                </p-button>
                <p-button
                    [attr.automation-id]="step.context.phaseId + '-Next'"
                    (buttonClicked)="nextClick(step)"
                    *ngIf="stepIndex + 1 < steps.length"
                    iconAfter="arrow-down"
                    [label]="'pStepper.nextStep' | translate"
                    [buttonType]="ButtonTypeEnum.Primary"
                >
                </p-button>
                <p-button
                    [attr.automation-id]="'Done'"
                    (buttonClicked)="nextClick(step)"
                    iconAfter="check"
                    *ngIf="isLastStep(stepIndex) && getStepState(step) == pStepState.active"
                    [label]="'Actions.done' | translate"
                    [buttonType]="ButtonTypeEnum.Primary"
                >
                </p-button>
            </div>
        </div>
    `,
    styleUrls: ['./p-stepper.component.scss']
})
export class PStepperComponent {
    @Input() steps: PStepConfig[] = [];
    @Input() activeStep: number = 0;
    @Output() nextStepClick = new EventEmitter<void>();
    @Output() prevStepClick = new EventEmitter<void>();

    public readonly pStepState = PStepState;

    public getStepState(step: PStepConfig): PStepState {
        const order = step.context.order;
        return order === this.activeStep ? PStepState.active : order > this.activeStep ? PStepState.disabled : PStepState.completed;
    }

    public isLastStep(stepIndex: number): boolean {
        return stepIndex + 1 == this.steps.length;
    }

    protected isDisplayButtonsBar(step: PStepConfig, stepIndex: number): boolean {
        return (
            this.getStepState(step) === PStepState.active ||
            (this.isLastStep(stepIndex) && this.getStepState(step) === PStepState.completed)
        );
    }

    protected nextClick(step: PStepConfig) {
        if (step.context.nextRequest) {
            step.context.nextRequest.emit();
        } else {
            this.nextStepClick.emit();
        }
    }

    protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
